// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExternalClaimAccumulatorModel } from './externalClaimAccumulatorModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1ClaimAccumulatorByMemberNumberResponse {
    'data': Array<ExternalClaimAccumulatorModel>;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1ClaimAccumulatorByMemberNumberResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<ExternalClaimAccumulatorModel>"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1ClaimAccumulatorByMemberNumberResponse.attributeTypeMap;
    }
}
